import '../../@types';

/** 是否是本地开发环境 */
export function isLocalEnv(): boolean {
    // return (window.$wujie?.location ?? location).hostname === 'localhost' || (window.$wujie?.location ?? location).hostname === '127.0.0.1';
    return /^localhost|\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/.test((window.$wujie?.location ?? location).hostname);
}

/** 是否是测试环境 */
export function isTestEnv(): boolean {
    return (window.$wujie?.location ?? location).hostname === 'events-test-1310788819.cos-website.ap-singapore.myqcloud.com';
}

/** 是否是正式环境 */
export function isProductEnv(): boolean {
    return (window.$wujie?.location ?? location).hostname === 'events.honorofkings.com';
}

/** 判断页面是否处于综合站 WUJIE 中 */
export function isInWujie(): boolean {
    // @ts-ignore
    return window.__POWERED_BY_WUJIE__ && !!window.$wujie.props.login;
}
